module.exports = __webpack_public_path__ + "static/media/27645c8a-608b-4abf-a2f1-c4407b576723.444aaf68.woff";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/27645c8a-608b-4abf-a2f1-c4407b576723.woff
// module id = 90
// module chunks = 0